"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tableClassName: function() {
        return tableClassName;
    },
    tableClassNames: function() {
        return tableClassNames;
    },
    useTableStyles_unstable: function() {
        return useTableStyles_unstable;
    }
});
const _react = require("@griffel/react");
const tableClassName = 'fui-Table';
const tableClassNames = {
    root: 'fui-Table'
};
const useTableLayoutStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f1w4nmp0",
        ha4doy: "fmrv4ls",
        a9b677: "fly5x3f",
        B73mfa3: "f14m3nip"
    }
}, {
    d: [
        ".f1w4nmp0{display:table;}",
        ".fmrv4ls{vertical-align:middle;}",
        ".fly5x3f{width:100%;}",
        ".f14m3nip{table-layout:fixed;}"
    ]
});
const useFlexLayoutStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "ftgm304"
    }
}, {
    d: [
        ".ftgm304{display:block;}"
    ]
});
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        po53p8: "fgkb47j",
        De3pzq: "fhovq9v"
    }
}, {
    d: [
        ".fgkb47j{border-collapse:collapse;}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}"
    ]
});
const useTableStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    const layoutStyles = {
        table: useTableLayoutStyles(),
        flex: useFlexLayoutStyles()
    };
    state.root.className = (0, _react.mergeClasses)(tableClassName, styles.root, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.root.className);
    return state;
}; //# sourceMappingURL=useTableStyles.styles.js.map
